import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatModule } from '../../shared/modules/mat.module';
import { CommentComponent } from './comment.component';

@NgModule({
  imports: [
    CommonModule,
    MatModule
  ],
  declarations: [CommentComponent],
  exports: [CommentComponent]
})
export class CommentModule {}
